module.exports = __webpack_public_path__ + "images/Heather_Ordway.jpg?v=25979d22756e76df12dde169d50d0aee";